<template>
    <div class="add_intervene_container">
        <div class="add_intervene_box">
            <p>新增干预</p>
            <div class="title_box">
                <span class="title">新增干预内容</span>
                <el-button @click="open_dialog">筛选壁纸</el-button>
            </div>
            <ul class="intervene_ul">
                <li class="intervene_li">
                    <div class="img_box">
                        <img src="https://img1.baidu.com/it/u=722430420,1974228945&fm=253&fmt=auto&app=138&f=JPEG?w=889&h=500" alt="">
                        <div class="">
                            <p>ID：111</p>
                            <p>www</p>
                        </div>
                    </div>
                    <span class="doc">展示位置</span>
                    <el-input type="text" placeholder="输入展示ID"/>
                </li>
            </ul>
        </div>
        <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="50%"
        :before-close="handleClose">
        <div>
            <CommTable :tableTitle="tableTitle" :tableData="tableData"/>
            <CommPagination :data_obj="data_obj" :page="page" :limit="limit"/>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
        </el-dialog>
    </div>
</template>

<script>
import CommTable from '@/components/comm_table/comm_table.vue'
import CommPagination from '@/components/comm_pagination/comm_pagination.vue'
export default {
    components:{
        CommTable,
        CommPagination
    },
    data(){
        return {
            dialogVisible:false,
            tableData:[
                {
                    id:1,
                    url:'https://img1.baidu.com/it/u=722430420,1974228945&fm=253&fmt=auto&app=138&f=JPEG?w=889&h=500',
                    user_id:'22',
                    status:1,
                },
                {
                    id:2,
                    url:'https://img1.baidu.com/it/u=722430420,1974228945&fm=253&fmt=auto&app=138&f=JPEG?w=889&h=500',
                    user_id:'22',
                    status:1,
                },
            ],
            tableTitle:[
                {prop:'id',label:'上线ID'},
                {prop:'url',label:'预览图',is_img:true},
                {prop:'user_id',label:'用户ID'},
                {prop:'status',label:'通过状态'},
            ],
            data_obj:{
                total:1
            },
            page:1,
            limit:10
        }
    },
    methods:{
        handleClose(){
            this.dialogVisible = false
        },
        open_dialog(){
            this.dialogVisible = true
        }
    }
}
</script>

<style lang="scss" scoped>
.add_intervene_container{
    .add_intervene_box{
        margin: 20px 0;
        .title_box{
            margin: 20px;
            .title{
                margin-right: 30px;
            }
        }
        .intervene_ul{
            .intervene_li{
                display: flex;
                align-items: center;
                .img_box{
                    display: flex;
                    align-items: center;
                    width: 300px;
                    border: 1px solid #ddd;
                    padding: 10px;
                    img{
                        width: 80px;
                        height: 80px;
                        border-radius: 50%;
                        margin-right: 10px;
                    }
                }
                .doc{
                    margin: 0 30px;
                }
                .el-input{
                    width: 200px;
                }
            }
        }
    }
}
</style>